module.exports = "---\nurl: \"http://api.infometric.se/help/openapi.json\"\ndom_id: \"#swagger-ui\"\nvalidatorUrl: \"\"\noauth2RedirectUrl: \"http://api.infometric.se/help/oauth2-redirect.html\"\n"


//////////////////
// WEBPACK FOOTER
// ./swagger-config.yaml
// module id = 519
// module chunks = 0